import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { Group } from '../../apiRtk/be4feApi';
import messages from './messages';

export interface FormData {
  group?: Array<Group>;
  hasForm?: boolean;
  name?: string;
}

function useAccessGroupFormValidationSchema() {
  const { formatMessage } = useIntl();
  return yup.object().shape({
    group: yup.array(),
    hasForm: yup.boolean(),
    name: yup.string().when('hasForm', {
      is: true,
      then: (schema) =>
        schema.required(formatMessage(messages.useAccessGroupFormValidationSchemaValidationRequiredName)),
    }),
  });
}

export default useAccessGroupFormValidationSchema;
